@if (
  {
    services: userService.fullUserDetails.userServices | async
  };
  as data
) {
  <div
    (click)="onCheckboxClick()"
    (keyup.enter)="onCheckboxClick()"
    (keyup.space)="onCheckboxClick()"
    role="checkbox"
    [attr.aria-checked]="searchService.search_objects[service]?.chosen"
    [attr.aria-label]="ariaLabel"
    [attr.aria-labelledby]="ariaLabel ? null : 'search booking-options-' + service"
    [attr.aria-describedby]="ariaDescribedBy"
    tabindex="0"
    class="item-main"
  >
    <div
      class="booking_option_button"
      [ngClass]="{
        'disabled-text': disabled,
        'disable-group': disableGroup,
        booking_option_button_active:
          !disableGroup &&
          (isComboButton ? comboSelected : searchService.search_objects[service]?.chosen)
      }"
      aria-live="assertive"
      aria-hidden="true"
    >
      <ng-content></ng-content>
    </div>
  </div>
}
